/* tslint:disable */

/**
 */
export class Shape {
    ID_SHAPE?: number;
    SHAPECODE?: number;
    SHAPEPICT?: string;
    SYM_1?: number;
    SYM_2?: number;
    SYM_3?: number;
    AXISYM_1?: number;
    AXISYM_2?: number;
    AXISYM_3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/shape.ts